import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import { getCollectionNode, setCollectionNode } from 'shared-utils/src/myCasaCollections';

import { useCtxGlobal } from '@client/app/Container';

import { MY_COLLECTIONS_IDS, MY_COLLECTIONS_TYPES } from 'shared-constants/src/mycasa26/collection_configurations';

import { saveAddressCollection, deleteAddressCollection } from '@client/helpers/MyCasaHelpers';


export default ({
  stateActions = {},
  saveAddressSuccessAction = null,
}) => {
  const {
    showSaveAddressDialog,
    user,
    logIn,
    showSynchingDialog,
    globalState,
  } = useCtxGlobal() || {};

  const getEvtPosition = () => {
    if (stateActions.setSaveAddressDialogOpenRef) {
      return 'AddressList';
    }
    return 'Map_Tooltip';
  };

  const saveAddressSuccess = (address, favorite) => {
    const portal26Domain = globalState && globalState.config && globalState.config.api && globalState.config.api.portal26;
    let recent = [];
    let favorites = [];

    if (stateActions.getRecents) {
      recent = stateActions.getRecents();
    } else {
      recent = getCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.RECENT)?.data || [];
    }

    if (stateActions.getFavorites) {
      favorites = stateActions.getFavorites();
    }

    const addressStreet = address.street || address.address;
    const addressTown = address.town || address.parent;
    const addressKey = `${addressStreet}-${addressTown}`;
    const removedFromRecent = recent.filter((item) => `${item.street}-${item.town}` === addressKey);
    const newRecent = recent.filter((item) => `${item.street}-${item.town}` !== addressKey);

    if (stateActions.setRecent) {
      stateActions.setRecent(newRecent);
    }

    setCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.RECENT, { data: newRecent, count: newRecent.length });

    const removedIds = removedFromRecent.map(i => i.id).filter(Boolean);
    if (removedIds.length) {
      deleteAddressCollection(portal26Domain, MY_COLLECTIONS_IDS.RECENT, removedIds);
    }

    // add favorite to favorites and to LS favorites
    const favs = (favorites || []).length ? favorites : getCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.SAVED)?.data || [];
    const newFavorites = [...favorite, ...favs];
    setCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.SAVED, { data: newFavorites, count: newFavorites.length });
    saveAddressCollection(portal26Domain, MY_COLLECTIONS_IDS.SAVED, favorite);

    trackGTMEvents({
      category: 'Interaction',
      action: 'SaveAddress',
      position: getEvtPosition(),
    }, null, true);

    if (saveAddressSuccessAction) {
      saveAddressSuccessAction({ newFavorites, favorite });
    }
  };

  const doSaveAddress = (address) => {
    trackGTMEvents({
      action: 'OpenSaveAddressModal',
      position: getEvtPosition(),
    }, null, true);
    showSaveAddressDialog({
      address,
      callback: saveAddressSuccess,
    });
  };

  const saveAddress = (address) => {
    if (user.isAuthenticated) {
      doSaveAddress(address);
    } else {
      if (stateActions.setSaveAddressDialogOpenRef) {
        stateActions.setSaveAddressDialogOpenRef();
      }
      logIn(
        () => showSynchingDialog({ afterSynchFn: () => doSaveAddress(address) }),
        'SaveAddress',
        getEvtPosition(),
      );
    }
  };

  return { saveAddress };
};
